import { withCriteriaProvider } from './makeCriteriaProvider';
import useSearchableProgramsWithHasMore, {
  useSearchableProgramsForFilteringResourceUsers
} from './useSearchablePrograms';

export const makeCriteriaProvider = (tag, context) =>
  withCriteriaProvider(tag, context, useSearchableProgramsWithHasMore);

export const makeEnhancedPMCriteriaProvider = (tag, context) =>
  withCriteriaProvider(
    tag,
    context,
    useSearchableProgramsForFilteringResourceUsers
  );

export { withCriteriaProvider } from './makeCriteriaProvider';
